<div class="section section-dark contact-background" id="kontakt">
  <div class="container">
    <h2 class="title text-center">Kontakt</h2>
    <hr class="section-hr reveal fade-width"/>
    <div class="row">
      <div class="col-lg-6">
        <h3>
          <a class="nav-link contact-link" title="Telefon" href="tel:{{contact.PHONE_NUMBER}}">
            <i class="description">
              <fa-icon [icon]="faPhone"></fa-icon>
            </i>
            <span class="description">{{ contact.PHONE_NUMBER_TEXT }}</span>
          </a>
        </h3>
        <h3>
          <a class="nav-link contact-link" title="E-mail" href="mailto:{{contact.EMAIL}}">
            <i class="description">
              <fa-icon [icon]="faAt"></fa-icon>
            </i>
            <span class="description">{{ contact.EMAIL }}</span>
          </a>
        </h3>
        <h3>
          <a class="nav-link contact-link" rel="noopener external" title="Adres" href="{{address.GOOGLE_MAPS_URL}}"
             target="_blank">
            <i class="description">
              <fa-icon [icon]="faMapLocationDot"></fa-icon>
            </i>
            <span class="description">{{ address.ADDRESS_LONG_TEXT }}</span>
          </a>
        </h3>
      </div>
      <div class="col-lg-6">
        <p class="description text-lg-start text-center h3-size">
          Wizyty umawiane są telefonicznie lub poprzez platformę Booksy.
          <br/>
          W razie jakichkolwiek pytań zapraszam do kontaktu.
        </p>
      </div>
    </div>
    <br/><br/>
    <div class="row">
      <div class="col-lg-12">
        @defer (on viewport) {
          <app-leaflet-map-wrapper></app-leaflet-map-wrapper>
        } @placeholder (minimum 500ms) {
          <div class="leaflet-placeholder-container">
            <div class="leaflet-placeholder"></div>
          </div>
        }
      </div>
    </div>
    <div class="row text-center text-lg-end privacy-policy description contact-link">
      <a class="description" routerLink="{{'/' + routes.PRIVACY_POLICY}}" target="_blank" rel="noopener">
        Polityka prywatności
      </a>
    </div>
  </div>
</div>
